import { Box, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 20,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "100%",
    },
  },
}));

const Feedback = (props) => {
  const classes = useStyles();
  const { value, setValue, disabled } = props;

  return (
    <div className={classes.root}>
      <Box component="fieldset" mb={3} borderColor="transparent">
        <Typography component="legend">
          Based on your recent purchase with Ace Hardware using Call and
          Collect, what specific suggestions and suggestions could be made to
          improve you overall satisfaction rating? We appreciate your candid
          responses.
        </Typography>

        <TextField
          disabled={disabled}
          defaultValue={value}
          id="outlined-multiline-static"
          label=""
          multiline
          rows={8}
          variant="outlined"
          onChange={(event) => {
            setValue(event.target.value);
          }}
        />
      </Box>
    </div>
  );
};

export default Feedback;
